import SectionCardRate from "./SectionCardRate";

export { SectionCardRate };
export default SectionCardRate;
